import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Collapse, Typography } from '@mui/material';
import { ReactNode, useState } from 'react';
import styled from 'styled-components';

export const Group = styled(Box)`
  border: 1px solid #dce4e8;
  border-radius: 4px;
`;

export const Title = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 15px;
`;

export const Body = styled(Box)`
  border-top: 1px solid #dce4e8;
  padding: 7px 17px;
`;

type ExpandableGroupProps = {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
};

export const ExpandableGroup = ({
  title,
  children,
  defaultExpanded = false,
}: ExpandableGroupProps) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Group>
      <Title sx={{ cursor: 'pointer' }} onClick={() => setExpanded(!expanded)}>
        <Typography>{title}</Typography>
        <ExpandMoreIcon
          sx={{
            color: 'rgba(0, 0, 0, 0.54)',
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease-in-out',
          }}
        />
      </Title>
      <Collapse in={expanded}>
        <Body>{children}</Body>
      </Collapse>
    </Group>
  );
};
